import { defaultPlaceholder } from "./defaultPlaceholder";
import { motivosForSucursalDepartamento } from "./motivosForSucursalDepartamento";

export const retriveMotivoData = (motivos, formik) => {
  const motivosOptions = motivosForSucursalDepartamento(motivos, formik)
    .map((motivo) => {
      return { label: motivo.titulo, value: motivo.itemId };
    })
    .sort((a, b) => (a.label > b.label ? 1 : -1));

  let value = motivosOptions.find((option) => {
    return option.value === formik.values.motivo;
  });
  value = value || null;

  if ((value && value.value) !== formik.values.motivo) {
    formik.setFieldValue("motivo", value && value.value);
  }

  const placeholder = formik.values.sucursaldepartamentoAsignado ? "Seleccione aqui el motivo" : defaultPlaceholder(formik);
  return [motivosOptions, placeholder, value];
};
